import { createReducer, on } from '@ngrx/store';
import * as actions from './se-side-key-images-container.actions';
import { clone, setWith } from 'lodash-es';
import {
    seSideKeyImagesInitialState,
    SeSideKeyImagesState,
} from './se-side-key-images-container.state';

export const seSideKeyImagesReducer = createReducer(
    seSideKeyImagesInitialState,
    on(actions.seSideKeyImagesComponentSetKeyImagesData, (state, { formType, keyImages }) => setKeyImagesData(state, formType, keyImages)),
    on(actions.seSideKeyImagesComponentNoResult, (state, { formType, message }) => setMessage(state, formType, message)),
    on(actions.seSideKeyImagesComponentSetSelectedItem, (state, { formType, selectedItems }) => setSelectedItem(state, formType, selectedItems))
);

export const updateSideKeyImagesState = (path: string, value: any, state: any) => setWith(clone(state), path, value, clone);

function setKeyImagesData(state: SeSideKeyImagesState, formType: any, keyImages:any[]): SeSideKeyImagesState {
    return updateSideKeyImagesState(`${formType}.keyImages`, keyImages, updateSideKeyImagesState(`${formType}.keyImages`, null, state));
}

function setSelectedItem(state: SeSideKeyImagesState, formType: any, selectedItems: any[]): SeSideKeyImagesState {
    return updateSideKeyImagesState(`${formType}.selectedItems`, selectedItems,
        updateSideKeyImagesState(`${formType}.message`, null, state));
}

function setMessage(state: SeSideKeyImagesState, formType: any, message: string): SeSideKeyImagesState {
    return updateSideKeyImagesState(`${formType}.patientId`, null,
        updateSideKeyImagesState(`${formType}.message`, message, state));
}

